import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../services/api";
import { format, parseISO } from "date-fns";

const reqStatusBadge = (status) => {
  const map = {
    "Pending":          "ims-badge-pending",
    "Approved":         "ims-badge-approved",
    "Rejected":         "ims-badge-rejected",
    "Issued":           "ims-badge-full",
    "Partially Issued": "ims-badge-partial",
  };
  return <span className={`ims-badge ${map[status] || "ims-badge-pending"}`}>{status}</span>;
};

const priorityBadge = (p) => {
  const cls = p === "High" ? "ims-badge-rejected" : p === "Low" ? "ims-badge-full" : "ims-badge-principal";
  return <span className={`ims-badge ${cls}`}>{p}</span>;
};

const ViewRequisition = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [requisition, setRequisition] = useState(null);
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`/requisitions/${id}`);
        setRequisition(res.data.requisition);
        setItems(res.data.items);
      } catch (err) {
        console.error("Error fetching requisition:", err);
      }
    };
    fetch();
  }, [id]);

  if (!requisition) {
    return (
      <div className="text-center py-5">
        <i className="fas fa-spinner fa-spin fa-2x text-primary"></i>
      </div>
    );
  }

  return (
    <div>
      {/* ── Page header ── */}
      <div className="ims-page-header">
        <div>
          <h4>Requisition — #{id}</h4>
          <p>Raised on {format(parseISO(requisition.created_date), "dd MMM yyyy")}</p>
        </div>
        <button className="btn btn-sm btn-secondary" onClick={() => navigate(-1)}>
          <i className="fas fa-arrow-left mr-1"></i> Back
        </button>
      </div>

      {/* ── Details card ── */}
      <div className="card shadow-sm mb-4" style={{ border: "none", borderRadius: "12px" }}>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <table style={{ fontSize: "13px", width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ color: "#64748b", width: "140px", paddingBottom: "8px" }}>Requested By</td>
                    <td><strong>{requisition.user_name}</strong></td>
                  </tr>
                  <tr>
                    <td style={{ color: "#64748b", paddingBottom: "8px" }}>Phone</td>
                    <td>{requisition.user_phone || "—"}</td>
                  </tr>
                  <tr>
                    <td style={{ color: "#64748b", paddingBottom: "8px" }}>Created Date</td>
                    <td>{format(parseISO(requisition.created_date), "dd/MM/yyyy")}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="col-md-6">
              <table style={{ fontSize: "13px", width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ color: "#64748b", width: "140px", paddingBottom: "8px" }}>Status</td>
                    <td>{reqStatusBadge(requisition.status)}</td>
                  </tr>
                  <tr>
                    <td style={{ color: "#64748b", paddingBottom: "8px" }}>Priority</td>
                    <td>{priorityBadge(requisition.priority)}</td>
                  </tr>
                  <tr>
                    <td style={{ color: "#64748b", paddingBottom: "8px" }}>Expected Date</td>
                    <td>{new Date(requisition.expected_date).toLocaleDateString("en-GB")}</td>
                  </tr>
                  {requisition.req_description && (
                    <tr>
                      <td style={{ color: "#64748b", paddingBottom: "8px", verticalAlign: "top" }}>Purpose</td>
                      <td>{requisition.req_description}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* ── Items ── */}
      <div className="card shadow-sm" style={{ border: "none", borderRadius: "12px" }}>
        <div className="card-header" style={{ background: "#f8fafc", borderRadius: "12px 12px 0 0", borderBottom: "1px solid #f1f5f9" }}>
          <strong style={{ fontSize: "14px" }}>
            <i className="fas fa-boxes mr-2 text-primary"></i>Items Requested
          </strong>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="ims-table">
              <thead>
                <tr>
                  <th>Item Name</th>
                  <th>Requested Qty</th>
                  <th>Approved Qty</th>
                </tr>
              </thead>
              <tbody>
                {items.length > 0 ? items.map((item) => (
                  <tr key={item.id}>
                    <td><strong>{item.item_name}</strong></td>
                    <td>{item.requested_quantity}</td>
                    <td>{item.approved_quantity || <span className="text-muted">—</span>}</td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="3" className="text-center text-muted py-4">No items found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewRequisition;
